import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangeDepartmentPayload } from '../types';
import {
  AFFILIATES_APPROVED_PERMISSIONS,
  AFFILIATES_LIST_QUERY_KEY,
  CHANGE_DEPARTMENT_API_URL,
  CHANGE_DEPARTMENT_MUTATION_KEY,
} from '../constants';

export default function useChangeDepartmentMutation(): IContextMutationResult<void, Error, IChangeDepartmentPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangeDepartmentPayload>({
    mutationKey: [CHANGE_DEPARTMENT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      CHANGE_DEPARTMENT_API_URL,
      payload,
      { permission: AFFILIATES_APPROVED_PERMISSIONS.UPDATE_DEPARTMENT_FOR_AFFILIATES },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATES_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
